module.exports = __webpack_public_path__ + "img/pic-2.ba9684ac.png";